import { NavLink } from "react-router-dom";

type Props = {
  leadName: string;
};

export function Breadcrumb({ leadName }: Props) {
  return (
    <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
      <NavLink
        to="/leads"
        className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors flex items-center justify-center"
      >
        <i className="ri-arrow-left-line text-base" />
      </NavLink>
      <NavLink to="/leads" className="hover:text-indigo-600 transition-colors whitespace-nowrap">
        Leads
      </NavLink>
      <span className="text-gray-300">/</span>
      <span className="text-gray-700 font-medium truncate">{leadName}</span>
    </div>
  );
}